import * as Yup from 'yup'
import { find } from 'lodash'

import { CartItemSchema } from './CartItemSchema'
import { IDeliveryMethod } from '@monorepo/interfaces'

type GetOrderSchemaProps = {
  deliveryMethods?: IDeliveryMethod[]
  minimumOrderAmount?: number
}

interface ICartItem {
  isSelected?: boolean
  price?: number
  amount?: number
}

export const getOrderSchema = ({
  deliveryMethods,
  minimumOrderAmount,
}: GetOrderSchemaProps) =>
  Yup.object().shape({
    contract: Yup.string().label('Договор').required(),
    paymentMethod: Yup.string().label('Способ оплаты').required(),
    deliveryType: Yup.string().label('Способ доставки').required(),
    deliveryAddress: Yup.string()
      .label('Адрес доставки')
      .when('deliveryType', {
        is: (deliveryTypeId) =>
          !!find(deliveryMethods, { id: deliveryTypeId })?.isAddressRequired,
        then: (schema: Yup.StringSchema) =>
          schema.min(10, 'Адрес указан не верно').required(),
      }),
    pickPoint: Yup.string()
      .label('Точка выдачи')
      .when('deliveryType', {
        is: (deliveryTypeId) =>
          !!find(deliveryMethods, { id: deliveryTypeId })?.isUsePickPoints,
        then: (schema: Yup.StringSchema) => schema.required(),
      }),
    customerComment: Yup.string(),
    items: Yup.array()
      .label('Товар')
      .of(CartItemSchema)
      .min(1, 'Не выбрано ни одного товара в корзине')
      .test(
        'min-order-sum',
        // Сообщение формируется динамически
        `Минимальная сумма заказа — ${minimumOrderAmount}\u00A0₽`,
        (items) => {
          // 1. Если лимита нет (0, null, undefined) — проверка всегда пройдена
          if (!minimumOrderAmount) return true

          if (!items) return false

          const total = (items as ICartItem[]).reduce((sum, item) => {
            // Считаем только выбранные товары с ценой
            if (item?.isSelected && item?.price) {
              const amount = item.amount || 0
              return sum + item.price * amount
            }
            return sum
          }, 0)

          // 2. Сравниваем с динамическим лимитом
          return total >= minimumOrderAmount
        }
      ),
  })
